import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Settings, AlertCircle, CheckCircle2, Database } from 'lucide-react';
import { Button } from '../ui/button';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const GlobalGA4Status = () => {
  const [globalSettings, setGlobalSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchGlobalSettings();
  }, []);

  const fetchGlobalSettings = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/api/integrations/ga4/global-settings`);
      setGlobalSettings(response.data);
      setError(null);
    } catch (err) {
      console.error('Error fetching global GA4 settings:', err);
      setError('Não foi possível carregar o status da integração global com o GA4.');
    } finally {
      setLoading(false);
    }
  };

  const handleManageSettings = () => {
    navigate('/system-settings');
  };

  if (loading) {
    return (
      <div className="flex items-center gap-2 px-3 py-1.5 rounded-md border border-border bg-background text-xs text-muted-foreground">
        <Database className="h-3.5 w-3.5" />
        <span>Carregando status GA4...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center gap-2 px-3 py-1.5 rounded-md border border-border bg-background text-xs text-muted-foreground">
        <AlertCircle className="h-3.5 w-3.5 text-orange-500" />
        <span>{error}</span>
      </div>
    );
  }

  if (!globalSettings) {
    return null;
  }

  const isActive = globalSettings.is_active;
  const useMockData = globalSettings.use_mock_data;

  return (
    <div className="flex items-center gap-3 px-3 py-1.5 rounded-md border border-border bg-background/50">
      {/* Integration Label */}
      <div className="flex items-center gap-1.5 text-xs">
        <Database className="h-3.5 w-3.5 text-muted-foreground" />
        <span className="font-medium text-foreground">Integração global GA4:</span>
      </div>

      {/* Status Pill */}
      <div className="flex items-center gap-1.5">
        {isActive ? (
          <div className="flex items-center gap-1 px-2 py-0.5 rounded-full bg-green-100 text-green-700 text-xs font-medium">
            <CheckCircle2 className="h-3 w-3" />
            <span>Ativa</span>
          </div>
        ) : (
          <div className="flex items-center gap-1 px-2 py-0.5 rounded-full bg-gray-100 text-gray-600 text-xs font-medium">
            <AlertCircle className="h-3 w-3" />
            <span>Inativa</span>
          </div>
        )}
      </div>

      {/* Data Mode Pill */}
      {isActive && (
        <div className="flex items-center gap-1.5">
          <span className="text-xs text-muted-foreground">Modo:</span>
          {useMockData ? (
            <span className="px-2 py-0.5 rounded-full bg-amber-100 text-amber-700 text-xs font-medium">
              Simulados (mock)
            </span>
          ) : (
            <span className="px-2 py-0.5 rounded-full bg-blue-100 text-blue-700 text-xs font-medium">
              Reais (GA4)
            </span>
          )}
        </div>
      )}

      {/* Manage Button */}
      <Button
        variant="ghost"
        size="sm"
        onClick={handleManageSettings}
        className="h-7 px-2 text-xs gap-1.5 text-muted-foreground hover:text-foreground"
      >
        <Settings className="h-3 w-3" />
        <span>Gerenciar</span>
      </Button>
    </div>
  );
};
